import { ApolloConsumer } from '@apollo/client';
import React from 'react';
import { Link } from 'react-router';
import shallowequal from 'shallowequal';
import filter from "../../filter";
import svgEdit from '../../svgs/edit.svg';
import plus from "../../svgs/plus-white.svg";
import { GET_CONTACT_VENDORS_LIST_QUERY } from '../Graphql/ContactsQueries/contactsQuery';
import Icon from '../Icon';
import LinkComp from "../LinkComp";
import ListResults from '../ListResults';
import { fetchData } from '../Service/graphQlService';
import SortTable from '../SortTable';


const limit = 50;

export default class VendorList extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			items: null,
			totalCount: null,
			error: null,
			isBusy: null,
		};
		this.client = null;
	}

	componentDidMount() {
		if (this.client) {
			this.fetch(this.props.location.query);
		}
	}
    parseSortOptions(orderQuery) {
        if (orderQuery && Array.isArray(orderQuery)) {
            return orderQuery.map((item, index) => {
                const [field, order] = item.split('.');
                return {
                    field: field,
                    order: order
                };
            });
        }
        else if (orderQuery) {
            const [field, order] = orderQuery.split('.');
            return [{
                field: field,
                order: order
            }];
        }
        else{
            return [];
        }

    }

    parseFilterOptions(query){
        const filterObject = {};
        if(query){
            for(const key in query){
                if(key !== 'order' && key !== 'page'){
                    filterObject[key]= query[key]
                }
            }
        }
        return [filterObject]
    }
	fetch(q) {
		this.setState({ isBusy: true });

		const query = { ...q };
		const options = filter(query, 'sellers');
		options.param.limit = limit;
		options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

		var pageParams = {
			page: query.page ? Number(query.page) : 1,
			pageSize: limit
		}
		
		const sortOptions = this.parseSortOptions(q.order);
        const filterOptions = this.parseFilterOptions(q); 
		if (this.client) {
			fetchData(GET_CONTACT_VENDORS_LIST_QUERY, {type: "Vendor",pageOptions: pageParams,filters:filterOptions, sortOptions: sortOptions})
			.then(res => {
					this.setState({
						items: res.data.getContacts.data,
						totalCount: res.data.getContacts.totalCount,
						error: null,
						isBusy: null,
					});
				})
				.catch(err => {
					this.setState({
						error: err.message,
						isBusy: null,
					});
				});
		}
		
		
	}

	componentDidUpdate(prevProps) {
		if (!shallowequal(prevProps.location.query, this.props.location.query)) {
			this.fetch(this.props.location.query);
		}
	}
	render() {
		const query = this.props.location.query;
		const itemsToDisplay = this.state.items ? this.state.items.slice(0, 50) : [];//newly added
		const columns = [
			{
				name: 'View',
				columnStyle: { width: 70 },
				// render: (el) => (
				// 	<Link to={{ pathname: `${arc.path.base}vendor/${el.contact_id}` }}><Icon svg={svgEdit} /></Link>
				// ),
				render: (el) => {
									const basePath = arc.path.base.endsWith('/') ? arc.path.base.slice(0, -1) : arc.path.base;
									const currentSearch = window.location.search;
									const currentPath = window.location.pathname + currentSearch;
								  
									return (
									  <Link to={{
										pathname:`${arc.path.base}vendor/${el.contact_id}`,
										state: { fromListUrl: currentPath }
									  }}>
										<Icon svg={svgEdit} />
									  </Link>
									);
								  }
			},
			{
				code: 'vendor_type',
				name: 'Vendor Type',
				render: (el) => el.vendor_type,
			}, 
					{
					code: 'first_name',
					name: 'First Name',
					render: (el) => el.first_name,
				}, {
					code: 'last_name',
					name: 'Last Name',
					render: (el) => el.last_name,
				}
			, {
				code: 'phone',
				name: 'phone',
				columnStyle: {
					minWidth: 132,
				},
				render: (el) => el.phone ?
					<a href={`tel:${el.phone.replace(' ', '-').replace('(', '').replace(')', '')}`}>{el.phone}</a> : null,
			},
			{
				code: 'email',
				name: 'email',
				render: (el) => el.email ? <a href={`mailto:${el.email}`}>{el.email}</a> : null,
			},  {
				code: 'company_name',
				name: 'Company Name',
				render: (el) => el.company_name,
			},  {
				code: 'company_address',
				name: 'Company Address',
				render: (el) => el.company_address,
			},  {
				code: 'city',
				name: 'City',
				render: (el) => el.company_city,
			},  {
				code: 'state',
				name: 'State',
				render: (el) => el.company_state,
			},  {
				code: 'zip',
				name: 'Zip',
				render: (el) => el.company_zip,
			}
		];

		return (
			<ApolloConsumer>
				{client => {
					if (!this.client) {
						this.client = client;
						this.fetch(this.props.location.query);
					}
					return (
						<div className='SellerList' data-is-busy={this.state.isBusy}>
							<div className='page-rounded-corner-container'>
								<div className='page-header-container list'>
									<div className='page-header list'>
										<div className='page-title'>Vendors</div>
										{/* <LinkComp to={`${arc.path.base}vendor`}> */}
											<LinkComp
												to={{
													pathname: `${arc.path.base}vendor`,
													state: { fromListUrl: window.location.pathname + window.location.search }
												}}
											>
											<div className="button-new plus positive">
												<Icon svg={plus} />
											</div>
										</LinkComp>
									</div>
									<div className='line' />
								</div>
							</div>
							<div className='page-body-container'>
								<SortTable columns={columns} items={this.state.items} query={query} hasSubColumns={true} classNameModifier='sellers' />
								<ListResults query={this.props.location.query} pathname={this.props.location.pathname} 
								error={this.state.error}
								totalCount={this.state.totalCount}
                                itemCount={itemsToDisplay.length}
								limit={limit} />
							</div>
						</div>
					)
				}}

			</ApolloConsumer>
		);
	}
}
